import React from 'react';
import { useTranslation } from 'react-i18next';
import ServiceDetail from '../components/ServiceDetail';
import dmImage from '../assets/dm.jpg';
import './DataMigration.css';

const DataMigration = () => {
  const { t } = useTranslation();
  const serviceData = t('serviceContent.dataMigration', { returnObjects: true });

  return (
    <div className="data-migration-page">
      <ServiceDetail serviceData={serviceData} serviceImage={dmImage} serviceKey="dataMigration" />
    </div>
  );
};

export default DataMigration;



